import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import {Redirect} from "react-router";
import {ErrorMessage, Field, Form, Formik} from "formik";
import {decodeData} from "../../../helpers";
import { PASSWORD_EXPIRED } from "../../../constants";

class ForgotPassword extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: {
                email: '',
            },
            status: {},
            url: (new URL(window.location)).searchParams.get("per")
        };

        this.formSubmit = this.formSubmit.bind(this);
        this.renderForm = this.renderForm.bind(this);
    }

    getHeaderText() {
            return decodeData(this.state.url) === PASSWORD_EXPIRED
                ? this.props.t('forms.expired_password')
                : this.props.t('forms.forgot_password');
    }

    render() {
        return (
            <div>

                <header className="text-white bg-primary-dark heading-block">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h1 className="heading-block__header">{this.getHeaderText()}</h1>
                            </div>
                        </div>
                    </div>
                </header>

                <div className="section window-layout">
                    <div className="container frame">
                        <div className="row">
                            <div className="col-12 my-4 mx-4">
                                <Formik
                                    initialValues={this.state.data}
                                    onSubmit={this.formSubmit}
                                    render={this.renderForm}
                                />

                                {this.state.status && this.state.status.msg && <div>{this.state.status.msg}</div>}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }

    renderForm(props) {
        return (
            <Form className="form form-layout mt-5 pb-2">
                <div className="container form-layout__2-col">
                    <p>{this.props.t('forms.forgot_password_explanation')}</p>

                    <div className="form-group col-12">
                        <label className="form-label" htmlFor="email">{this.props.t('forms.email')}</label>
                        <Field type="text" name="email" id="email" autoComplete="email"
                               className={'form-control' + (props.errors.email && props.touched.email ? ' is-invalid' : '')}/>
                        <ErrorMessage name="email" component="div" className="invalid-feedback"/>
                    </div>

                    {props.status && props.status.msg && <div>{props.status.msg}</div>}

                    <div className="form-group col-12">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={props.isSubmitting}
                        >
                            {this.props.t('forms.continue_btn')}
                        </button>
                    </div>
                </div>
            </Form>
        );
    }

    formSubmit(values, actions) {
        actions.setStatus({});

        axios.post('/api/user/forgot_password', values)
            .then(
                data => {

                    if (data.data.status === 'success') {
                        actions.setSubmitting(true);
                        actions.setStatus({msg: data.data.message})
                    } else {
                        actions.setSubmitting(false);
                    }
                },
                error => {
                    let response_data = error.response.data;
                    actions.setSubmitting(false);
                    actions.setErrors(response_data.errors);
                    actions.setStatus({msg: response_data.msg})
                }
            )
            .catch((a, b, c) => {
                console.log(a, b, c);
            });
    }
}

export default withTranslation()(ForgotPassword);
